import React, { Component, Fragment } from 'react';

import * as Func from '../../../../../../helpers/functions';
import { DATE_TIME_FORMAT, ORDER, PATHS } from '../../../../../../constants/Define';
import i18n from '../../../../../../constants/initLng';
import { getMomentDate } from '../../../../../../utils/commonUtils';
import {
    FormWrapperItem, ListComponent, StatusComponent, FormWrapperInputComponent
} from "../../../../common/component/Index";
import OrderTourItemDetail from './OrderTourItemDetail';
import Wrapper from "../../../../common/component/Wrapper";
import Span from "../../../../common/component/Span";
import { Skeleton, Icon, Tooltip, message, Typography } from 'antd';
import Order, { OrderTourItem } from '../../../../../../models/Order';
import moment from 'moment';
import * as HMS from "containers/backend/common/component/Index";
import PopupFlight from '../PopupFlight/PopupFlight';

import './TourInfo.less';
import SurchargeInfo from '../SurchargeInfo/SurchargeInfo';
import RedeemTour from './RedeemTour';
import SurchargeTourDetail from './SurchargeTour';
import { get, pick } from 'lodash';
import { syncDateByItiNumber } from '../../../../../../services/syncDateByItiNumberService';
import Ripple from './../../../../common/component/Ripple/index';
import CustomersModal from './CustomersModal';
import AntSelect, { AntOption } from 'containers/backend/common/component/AntSelect';
import Input from 'containers/backend/common/component/Input';
let columnTable = [
    'action', 'type', 'tourName', 'ticketName', 'rateCode', 'seatNo', 'ticketType',
    'objectType', 'originalPrice', 'prices', 'salePrice', 'refundConfirmed', 'refundWaiting', 'tourSerialNumber', 
    'ticketStatus', 'tourStatus', 'status', 'operaBooking', 'note', 'checkInDate', 
    'checkOutDate', 'propertyName', 'redeemProperty', 'outletInfo', 'serviceName', 'sessionInfo' ,'confirmNumber', 'property', 'effectiveStartDate', 'effectiveEndDate', 'properties', 'redeemPropertyId', 'loyaltyCampaignCode', 'loyaltyLinkType', 'loyaltyLinkValue', 'loyaltyCommitStatus', 'giftPointValue', 'giftPointCommitStatus']

const removedColumns = [
    'orderId', 'type', 'productVariantId', 'tourCode', 'lengthOfTour',
    'quantity', 'departureDate', 'salePrice',
    'childOriginalPrice', 'childSalePrice', 'childQuantity',
    'infantOriginalPrice', 'infantSalePrice', 'infantQuantity', 'serialNumber', 'status', 'objectType', 'property', 'redeemPropertyId', 'properties'
];
const OrderTourItemKeys = Object.getOwnPropertyNames(new OrderTourItem());
const statusDisabledChange = [4, 5, 13]
const hasValue = value => value !== undefined && value !== null && value !== '';

const formatSessionTime = session => {
    if (!session?.sessionId) return '';
    const padMinute = minute => (minute === 0 ? '00' : minute);
    return `${session.startHour}:${padMinute(session.startMinute)} - ${session.endHour}:${padMinute(session.endMinute)}`;
};

const getSessionInfos = record => {
    const comboData = record?.comboData || [];

    if (comboData.length) {
        const rows = record.objectTypeCombos?.length ? record.objectTypeCombos : comboData;
        return rows.map(row => (comboData.find(combo => combo.rateCodeId === row.rateCodeId) || {}).sessionInfo);
    }

    return [record?.sessionInfo];
};

const {Text} = Typography;
export default class TourInfo extends Component {
    constructor(props) {
        super(props);

        // hide action column if type is vinwonder new
        let columns = this.hideActionColumn(this.props, columnTable);
        // hide status VW column if type is not vinwonder new
        columns = this.hideTicketStatusColumn(this.props, columns);
        // hide serviceName column if type is not vinwonder new
        columns = this.hideServiceNameColumn(this.props, columns);
        const additionalColumns = this.props.permissionFlightTracking ? ['flightInfo'] : [];

        this.state = {
            titleOrderItemTable: Func.getTitleTable(columns, additionalColumns, [...removedColumns, `${(!this.props.permissionFlightTracking?.allowView && !this.props.permisions.allowView) ? 'flightInfo' : ''}`]),
            modelOrderItem: OrderTourItemKeys,
            componentTable: {
                tourName: {
                    width: 350
                },
                rateCode: {
                    key: 'rateCode',
                    render: (rateCode, record) => {
                        let rateCodes = [pick(record, ["rateCodeId", "rateCode"])];

                        if (record.objectTypeCombos?.length) {
                            // combo vinwonders
                            rateCodes = record.objectTypeCombos.map(x => ({
                                rateCodeId: x.rateCodeId,
                                rateCode: x.rateCodeCode
                            }));
                        }

                        return rateCodes.map(item => (
                            <div key={item.rateCodeId} className="ratecode-open-new" onClick={() => this.onOpenRateCode(item.rateCodeId)}>
                                {item.rateCode}
                            </div>
                        ))
                    }
                },
                seatNo: {
                    width: 120,
                    render: (seatNo, record) => {
                        let seatNos = [record.seatNo];

                        if (record.objectTypeCombos?.length) {
                            const comboSeatNos = record.objectTypeCombos.map(x => x.seatNo);
                            seatNos = comboSeatNos.some(hasValue) ? comboSeatNos : seatNos;
                        }

                        return seatNos.map((value, index) => <div key={index}>{value}</div>);
                    }
                },
                ticketType: {
                    width: 250,
                    render: (text, record) => {
                        let types = [record.objectType ? record.objectType.name : i18n.t(`item.order.${text}`)];

                        if (record.objectTypeCombos?.length) {
                            // combo vinwonders
                            types = record.objectTypeCombos.map(x => x.objectTypeName);
                        }
    
                        return types.map(t => <div>{t}</div>);
                    }
                },
                originalPrice: {
                    render: (text, record) => {
                        let prices = [text];

                        if (record.objectTypeCombos?.length) {
                            // combo vinwonders
                            prices = record.objectTypeCombos.map(x => x.originalPrice);
                        }

                        return prices.map(p => <div>{`${Func.formatMoney(p)} ${i18n.t(`currencySymbol`)}`}</div>);
                    }
                },
                prices: {
                    render: (text, record) => {
                        let prices = [record.salePrice];
                        
                        if (record.objectTypeCombos?.length) {
                            // combo vinwonders
                            prices = record.objectTypeCombos.map(x => x.salePrice);
                        }

                        return prices.map(p => <div>{`${Func.formatMoney(p)} ${i18n.t(`currencySymbol`)}`}</div>);
                    }
                },
                refundConfirmed: {
                    key: 'refundConfirmed',
                    render: (text, record) => {
                        let refundValues = [record.refundConfirmed];
                        
                        if (record.objectTypeCombos?.length) {
                            // combo vinwonders
                            refundValues = record.objectTypeCombos.map(x => x.refundConfirmed);
                        }

                        return refundValues.map(v => <div>{v}</div>);
                    }
                },
                refundWaiting: {
                    key: 'refundWaiting',
                    render: (text, record) => {
                        let refundValues = [record.refundConfirmed];
                        
                        if (record.objectTypeCombos?.length) {
                            // combo vinwonders
                            refundValues = record.objectTypeCombos.map(x => x.refundWaiting);
                        }

                        return refundValues.map(v => <div>{v}</div>);
                    }
                },
                tourSerialNumber: {
                    key: 'serialNumber',
                    render: (text, record) => {
                        let checkCodes = [record.serialNumber];
                        
                        if (record.objectTypeCombos?.length) {
                            // combo vinwonders
                            checkCodes = record.objectTypeCombos.map(x => x.tourSerialNumber);
                        }

                        return checkCodes.map(c => <div>{c}</div>);
                    }
                },
                loyaltyCommitStatus: {
                    key: 'loyaltyCommitStatus',
                    render: (status, record) => {
                        return (
                            record.loyaltyLinkType === "POINT" &&
                            <Fragment>
                                <StatusComponent
                                    color={i18n.t(`item.order.itemLoyaltyCommitStatusColor.${status}`)}
                                    label={i18n.t(`item.order.itemLoyaltyCommitStatus.${status}`)} />
                            </Fragment>
                        )
                    },
                },
                giftPointCommitStatus: {
                    key: 'giftPointCommitStatus',
                    render: (status, record) => {
                        return (
                            record.giftPointValue > 0 &&
                            <Fragment>
                                <StatusComponent
                                    color={i18n.t(`item.order.itemGiftPointCommitStatusColor.${status}`)}
                                    label={i18n.t(`item.order.itemGiftPointCommitStatus.${status}`)} />
                            </Fragment>
                        )
                    },
                },
                ticketStatus: {
                    key: 'ticketStatus',
                    render: (status, record) => {
                        let statusList = [status];

                        if (record.objectTypeCombos?.length) {
                            // combo vinwonders
                            statusList = record.objectTypeCombos.map(x => x.ticketStatus);
                        }

                        return statusList.map(value => <div><StatusComponent color={this.props.t(`item.order.orderItemVWStatusColor.${value}`)}
                            label={this.props.t(`item.order.orderItemVWStatus.${value}`)} /></div>)
                    },
                },
                operaBooking: {
                    key: 'operaBooking',
                    render: (text, record) => {
                        // record.status == 3 -> đã dùng
                        return <div className={record?.status == 3 && 'opera-booking'}  onClick={() => { record?.status == 3 && this.callOperaBooking(record)} }>
                            {record.operaBooking} 
                        </div>
                    }
                },
                checkInDate: {
                    render: (date, record) =>{
                        if(record.checkInDate && (record.type === 2 || record.type === 7 || (record.type === 1 && record.operaBooking))) {
                            return getMomentDate(record.checkInDate).format(DATE_TIME_FORMAT.SHORT_DATE)
                        }
                        // return date && record.type === 2  && record.operaBooking  && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)}
                        return date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)}
                },
                checkOutDate: {
                    render: (date, record) => {
                        if(record.checkOutDate && (record.type === 2  || record.type === 7 || (record.type === 1 && record.operaBooking))) {
                            return getMomentDate(record.checkOutDate).format(DATE_TIME_FORMAT.SHORT_DATE)
                        }
                        //  return date && record.type === 2 && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)
                         return date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)
                        
                    }
                },
                effectiveStartDate: {
                    render: (date, record) => date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                effectiveEndDate: {
                    render: (date, record) => date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                tourStatus: {
                    key: 'tourStatus',
                    render: (value, record) => (
                        record.status != null && 
                            <Fragment>
                                <StatusComponent 
                                    color={i18n.t(`item.order.orderItemStatusColor.${record.status}`)}
                                    label={i18n.t(`item.order.orderItemStatus.${record.status}`)} />
                                {record.isLocked && <Icon type="lock" style={{ color: 'red' }}  />}
                            </Fragment>
                    ),
                },
                propertyName: {
                    key: 'propertyName',
                    render: (value, record) => {
                        if(record.status === 3) {
                            return !!record.redeemProperty && record.redeemProperty.name
                        }
                        return record.properties.map(property => <p key={property.id}>{property.name}</p>)
                    }
                },
                redeemProperty: {
                    key: 'redeemProperty',
                    render: (value, record) => {
                        if(record.status === 3) {
                            return !!record.redeemProperty && record.redeemProperty.name
                        }
                        return
                    }
                },
                outletInfo: {
                    width: 200,
                    key: 'outletInfo',
                    render: (text, record) => {
                        if (!record.sessionInfo || !record?.sessionInfo?.sessionId) return null;
                        return <Wrapper className="booking-session-cell">
                                        {record.sessionInfo.nameOutlet}
                                    </Wrapper>
                    }
                },
                serviceName: {
                    width: 200,
                    key: 'serviceName',
                    render: (text, record) => {
                        const comboServiceNames = (record.objectTypeCombos || [])
                            .map(x => x.serviceName)
                            .filter(hasValue);
                        const serviceNames = [...new Set(
                            comboServiceNames.length
                                ? comboServiceNames
                                : [record.sessionInfo?.serviceName || text].filter(hasValue)
                        )];

                        if (!serviceNames.length) return null;

                        return <Wrapper className="booking-session-cell">
                            {serviceNames.map((name, index) => <div key={index}>{name}</div>)}
                        </Wrapper>;
                    }
                },
                sessionInfo: {
                    width: 120,
                    key: 'sessionInfo',
                    render: (text, record) => {
                        const sessions = getSessionInfos(record);
                        if (!sessions.some(session => !!session?.sessionId)) return null;
                        return <Wrapper className="booking-session-cell">
                                        {sessions.map((session, index) => <div key={index}>{formatSessionTime(session)}</div>)}
                                    </Wrapper>
                    }
                },
                action: {
                    width: 120,
                    // fixed: 'right',
                    align: 'center',
                    render: (text, record) => (
                        <Wrapper>
                            {
                                (record.status === 2 || record.status === 7) && this.props.permissionTourActions.allowRedeem && record.refundWaiting <= 0 && record.refundConfirmed <= 0 &&
                                <Tooltip title={this.props.t(`action.redeem`)} placement="top">
                                    <Icon type="check" className="fs20 colorPrimary" onClick={() => this.showRedeemTour(record)} />
                                </Tooltip>
                            }
                            {
                                !statusDisabledChange.includes(record.status) && this.props.permisions.allowChangeStatus && record.refundWaiting <= 0 && record.refundConfirmed <= 0 &&
                                <Tooltip title={i18n.t(`action.edit`)} placement="top">
                                    <Icon type="edit" className="fs20 colorPrimary" onClick={() => this.onClickEditTourItem(record)} />
                                </Tooltip>
                            }
                            {
                                this.props.allowSurcharge && record.refundWaiting <= 0 && record.refundConfirmed <= 0 &&
                                <Tooltip title={this.props.t(`action.newSurchange`)} placement="top">
                                    <Icon 
                                        type="file-add" 
                                        className="fs20 colorPrimary" 
                                        // onClick={() => this.props.createModalSurcharge(record.itemVariantId, ORDER.TYPES.TOUR.id)} 
                                        onClick={() => this.showModalSurcharge(record.itemVariantId, record.productVariantId)} 
                                    />
                                </Tooltip>
                            }
                            {
                                record.status === 2 && this.props.permisions.allowLockItem && record.refundWaiting <= 0 && record.refundConfirmed <= 0 &&
                                <Tooltip title={this.props.t(`action.${record.isLocked ? 'unlockItem' : 'lockItem'}`)} placement="top">
                                    <Icon type={`${record.isLocked ? 'unlock' : 'lock'}`} className="fs20 colorPrimary" onClick={() => this.onLockItem(record)} />
                                </Tooltip>
                            }
                            {
                                record.rateCodeId && record.status !== 3 && <Tooltip title={this.props.t(`action.changeRateCote`)} placement="top">
                                    <Icon type="retweet" className="fs20 colorPrimary" onClick={() => this.props.onChangeRateCode(record.rateCodeId, record.itemVariantId, 2)} />
                                </Tooltip>
                            }
                        </Wrapper>
                    )
                },
                flightInfo: {
                    key: 'flightInfo',
                    align: 'center',
                    render: (tour, record) => {
                        const flightTrackingOrderItem = (this?.props?.orderState?.detail?.flightTrackingOrder || []).find(el => el.itemVariantId === record?.itemVariantId);
                        return(<Wrapper>
                            <Text className='cursor-pointer' underline onClick={() => this.handleOpenPopupFlight(record.itemVariantId)}>{flightTrackingOrderItem?.airlineNumber ?? 'Thêm chuyến bay'}</Text>
                            {(this.state.showPopupFlightInfo && this.state.showPopupFlightInfo===record.itemVariantId) && <PopupFlight 
                                            handleClosePopupFlight={this.handleClosePopupFlight}
                                            t={this.props.t}
                                            selectFilterSearch={this.selectFilterSearch}
                                            airportDeparture={this.props.airportDeparture}
                                            airportArrival={this.props.airportArrival}
                                            airlineDomestic={this.props.airlineDomestic}
                                            tour={record}
                                            order={this.props.orderState.detail.order}
                                            permissionsFlightTracking={this.props.permissionFlightTracking}
                                            permissionsOrder={this.props.permisions}
                                            createFlightTracking={this.props.createFlightTracking}
                                            updateFlightTracking={this.props.updateFlightTracking}
                                            deleteFlightTracking={this.props.deleteFlightTracking}
                                            flightTrackingOrderItem={flightTrackingOrderItem}
                                        />}
                        </Wrapper>)
                    }
                }
            },
            tourItemEditing: null,
            tourItemSelect: null,
            selectDataTour: null,
            SurchargeId: null,
            customersList: null,
            showPopupFlightInfo: null
        };
    }

    componentDidMount() {
        this.props.getListFlightTrackingOrder(this.props.orderId);
    }

    hasSeatNoData = (tours = []) => {
        return tours.some(item => {
            if (hasValue(item?.seatNo)) return true;
            return (item?.objectTypeCombos || []).some(combo => hasValue(combo?.seatNo));
        });
    }

    getTitleOrderItemTable = (tours = []) => {
        let columns = this.hideActionColumn(this.props, columnTable);
        columns = this.hideTicketStatusColumn(this.props, columns);
        columns = this.hideServiceNameColumn(this.props, columns);
        const dynamicRemovedColumns = [...removedColumns];

        if (!this.hasSeatNoData(tours)) {
            dynamicRemovedColumns.push('seatNo');
        }

        if (!this.props.permissionFlightTracking?.allowView && !this.props.permisions.allowView) {
            dynamicRemovedColumns.push('flightInfo');
        }

        const additionalColumns = this.props.permissionFlightTracking ? ['flightInfo'] : [];
        return Func.getTitleTable(columns, additionalColumns, dynamicRemovedColumns);
    }

    render() {
        const { t, tours, loading, customers, airlineDomestic, airportDeparture, airportArrival, permisions, isVinwonderNew } = this.props;
        const { modelOrderItem, componentTable, tourItemEditing, tourItemSelect, selectDataTour, showPopupFlightInfo } = this.state;
        return (
            <Fragment>
                <Wrapper className="tour-info-section col-md-12 mt-2 mb-3">
                    <div className="d-flex justify-content-between mt-2">
                        <h3 className={`ml-0`}>{isVinwonderNew ? t('item.order.vinwondersInfo') : t('item.order.tourInfo')}</h3>
                        {
                            (customers && customers.length > 0) && 
                            <Wrapper className="editing-buttons">
                                <Ripple waitForEffect={true} className={`btn-edit p-1`} onClick={this.handleOpenCustomers}>{t(`item.order.customersList`)}</Ripple>
                            </Wrapper>
                        }
                    </div>
                    <Wrapper className={`row mt-2`}>
                        <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                            {!loading ?
                                <ListComponent
                                    classParent="m-0 p-0 col-md-12"
                                    scroll={{ x: 3500 }}
                                    autoResize={isVinwonderNew}
                                    marginTop={'0'} marginBottom={'0'}
                                    loading={{ spinning: loading, size: 'large' }}
                                    rowKey={(record, k) => record.id ? record.id : k}
                                    dataSource={Func.getDataSource(tours || [], modelOrderItem)}
                                    columns={Func.columnsTable({
                                        titleTable: this.getTitleOrderItemTable(tours || []),
                                        component: componentTable,
                                        itemName: 'order'
                                    })}
                                    hideSettings={true}
                                    componentTableList={{}}
                                    expandedRowRender={this.renderSurcharge}
                                    onExpand={this.onRowExpanded}
                                />
                            
                                : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                            }
                        </FormWrapperItem>
                    </Wrapper>
                    <OrderTourItemDetail
                        title={`${t(`action.edit`)} ${t('item.order.tourInfo').toLowerCase()}`}
                        visible={!!tourItemEditing}
                        onSave={this.onSaveTourItem}
                        itemTypes={ORDER.TYPE_ITEM['2']}
                        onClose={() => this.setState({ tourItemEditing: null })}
                        item={tourItemEditing || {}}
                        rateCodeDetail={this.props.rateCodeDetail}
                        orderState={this.props.orderState}
                    />
                    { !!tourItemSelect && <RedeemTour 
                        title={`${t(`action.redeem`)} ${t('item.order.tourItemTicket').toLowerCase()}`}
                        visible={!!tourItemSelect}
                        onSave={this.onRedeemTourItem}
                        // itemTypes={ORDER.TYPE_ITEM['2']}
                        onClose={() => this.setState({ tourItemSelect: null })}
                        item={tourItemSelect || {}}
                    />
                    }
                    <CustomersModal
                        title={t('item.order.customersList')}
                        visible={!!this.state.customersList}
                        onClose={() => this.setState({ customersList: null })}
                        items={this.state.customersList}
                    />
                </Wrapper>
                {!!selectDataTour &&
                    <SurchargeTourDetail 
                        isOpen={!!selectDataTour}
                        infoItem={selectDataTour}
                        destroySurcharge={() => this.setState({ selectDataTour: null })}
                        orderState={this.props.orderState}
                    />
                }
            </Fragment>
        );
    }

    showModalSurcharge = (itemVariantId, productVariantId) => {

        this.setState({
            selectDataTour: {
                itemVariantId,
                productVariantId,
                orderId: this.props.orderId,
                orderCode: this.props.orderCode
            }
        })
    }

    handleOpenPopupFlight = (id) => {
        this.setState({
            showPopupFlightInfo: id
        })
    }
    handleClosePopupFlight = () => {
        this.setState({
            showPopupFlightInfo: null
        })
    }


    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option?.props?.children?.toString().toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    renderSurcharge = (record, index, indent, expanded) => {
        return (
            <SurchargeInfo
                listType='tours'
                removeSurcharge={this.props.removeSurcharge}
                surcharges={record.detail.items}
                loading={false}
                openModalDetail={this.openDetailSurcharge}
            />
        )
    }

    openDetailSurcharge = (itemVariantId, id, listType) => {
        this.setState({
            selectDataTour: {
                itemVariantId,
                orderId: this.props.orderId,
                orderCode: this.props.orderCode,
                id
            }
        })
    }

    onRowExpanded = (expanded, record) => {
        if (expanded && record.itemVariantId) {
            this.props.onItemExpanded(expanded, record, 'tours')
        }
    }

    showRedeemTour = (orderItem) => {
        this.setState({ tourItemSelect: { ...orderItem, orderId: this.props.orderId } })
    }

    onRedeemTourItem = (orderItem) => {
        // if(this.props.onUpdateItem){
        //     orderItem.orderItemType = 2;
        //     this.props.onUpdateItem(orderItem)
        // }
        this.setState({ tourItemSelect: null })
    }

    onClickEditTourItem = (orderItem) => {
        this.props.getRateCodeDetail(orderItem.rateCodeId)
        this.setState({ tourItemEditing: orderItem })
    }

    onSaveTourItem = (orderItem) => {
        if(this.props.onUpdateItem){
            orderItem.orderItemType = 2;
            this.props.onUpdateItem(orderItem, {
                onSuccess: () => this.setState({ tourItemEditing: null })
            })
        }
        // this.setState({ tourItemEditing: null })
    }

    onLockItem = (orderItem) => {
        orderItem.orderItemType = 2;
        this.props.showConfirmLockItem(orderItem, orderItem.ticketName)
    }

    onOpenRateCode = (rateCodeId)=>{
        window.open(`${PATHS.RATECODE.CREATE.path}/${rateCodeId}`);
    }
    
    callOperaBooking = async (value) => {
        const idBooking = value.operaBooking;      
        try {
            const res = await syncDateByItiNumber(idBooking);
            message.success('Thành công');
            if(res){
                setTimeout((window.location.reload()), 2000);
            }            
        } catch (error) {
            return message.error(error?.errors[0]?.message || 'Đã có lỗi xảy ra')            
        }  
    }

    hideActionColumn = (props, columns) => {
        if(props.isVinwonderNew){
            return [...columns.filter(x=>x !== "action")];
        }

        return [...columns];
    }

    hideTicketStatusColumn = (props, columns) => {
        if(!props.isVinwonderNew){
            return [...columns.filter(x=>x !== "ticketStatus")];
        }
        return [...columns];
    }

    hideServiceNameColumn = (props, columns) => {
        if (!props.isVinwonderNew) {
            return [...columns.filter(x => x !== 'serviceName')];
        }
        return [...columns];
    }

    handleOpenCustomers = () => {
        const { customers } = this.props;
        this.setState({ customersList: customers });
    }
}

TourInfo.defaultProps = {
    order: new Order(),
    loading: false,
    data: {},
};
